import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { AuthShell } from "@/components/auth/auth-shell";
import { BrandPanel } from "@/components/auth/brand-panel";
import { FormPanel } from "@/components/auth/form-panel";
import { FormPanelHeader } from "@/components/auth/form-panel-header";
import { FormHeading } from "@/components/auth/form-heading";
import SignInForm from "@/components/auth/SignInForm";

export const Route = createFileRoute("/_auth/signin")({
  component: SignInPage,
});

function SignInPage() {
  const t = useTranslations();

  return (
    <AuthShell>
      <BrandPanel page="signin" />
      <FormPanel>
        <FormPanelHeader
          linkOpposite={{
            href: "/signup",
            prompt: t("auth.signin.no_account"),
            cta: t("auth.signin.link_signup"),
          }}
        />
        <FormHeading
          title={t("auth.signin.title")}
          description={t("auth.signin.desc")}
        />
        <SignInForm />
      </FormPanel>
    </AuthShell>
  );
}
